class Util {

    static maskPan(pan) {
        if (pan.length < 10)
            return pan;
        return `${pan.substring(0, 6)}${pan.substring(6, pan.length - 4).replace(/./g, "*")}${pan.substring(pan.length - 4)}`;
    }
    static clone(obj) {
        return Object.assign({}, obj);
    }

    static regularFormString(val) {
        return val ? val.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); }) : null;
    }
    static defaultMapStateToProps(state, props) {
      
        return {
            userPermissions: state.permissions
        };
        
    }
}

export default Util;



// WEBPACK FOOTER //
// ./src/util/util.js